import { ChangeDetectionStrategy, Component, inject, OnInit, output, signal } from "@angular/core";
import { HeaderComponent, MenuElement, Representation } from "@husbanken/designsystem-angular-header-v2";
import { AsyncPipe } from "@angular/common";
import { UserQuery } from "../../queries/user.query";
import { UserRepresentsQuery } from "../../queries/user-represents.query";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-header",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, AsyncPipe, TranslatePipe],
  template: `
    <hb-header-v2
      [serviceName]="'Send dokumenter digitalt' | translate"
      [languageLabel]="languageLabel()"
      [menu]="menu"
      [languageListInfo]="languageList"
      (changeLanguage)="changeLanguage.emit($event)"
      [user]="userQuery.headerUser$ | async"
      [currentRepresentation]="userRepresentsQuery.headerRepresentation$ | async"
      [representationList]="userRepresentsQuery.headerRepresentationList$ | async"
      (changeRepresentation)="changeRepresentation.emit($event)"
      [displayRepresentMyself]="false"
      (logout)="logout.emit()"
    >
    </hb-header-v2>
  `,
})
export class AppHeaderComponent implements OnInit {
  public languageLabel = signal<string>('Language');

  public userRepresentsQuery = inject(UserRepresentsQuery);
  public userQuery = inject(UserQuery);

  public changeLanguage = output<string>();
  public changeRepresentation = output<Representation>();
  private translateService = inject(TranslateService);
  public logout = output<void>();

  ngOnInit(): void {
    this.languageLabel.set(this.translateService.currentLang == 'en' ? 'Language' : 'Språk')
    this.translateService.onLangChange.subscribe(val => {
      this.languageLabel.set(val.lang == 'en' ? 'Language' : 'Språk')
    })
  }

  public menu: MenuElement[] = [
  ];

  protected languageList = [
    {
      code: "nb",
      name: "Bokmål",
    },
    {
      code: "nn",
      name: "Nynorsk",
    },
    {
      code: "en",
      name: "English",
    },
  ];
}
